import { notifStore } from "@/stores/notif.js";

export default {
  showInfo(message, autoHide, title) {
    const notif = notifStore();
    const duration = autoHide ?? 5000;
    notif.create({
      kind: "success",
      title: title && title != "" ? title : "INFO",
      autoHide: autoHide ? autoHide : 5000,
      message: message,
    });
    setTimeout(() => {
      notif.hide();
    }, duration);
  },

  showError(message, autoHide, title) {
    const notif = notifStore();
    const duration = autoHide ?? 3000;

    // Handle both string messages and error objects
    let errorMessage;
    if (typeof message === "string") {
      errorMessage = message;
    } else {
      errorMessage = this.getErrorMessage(message);
    }

    notif.create({
      kind: "error",
      title: title && title != "" ? title : "ERROR",
      message: errorMessage,
      autoHide: duration,
    });

    setTimeout(() => {
      notif.hide();
    }, duration);
  },

  getErrorMessage(e) {
    if (e == undefined || e == null) return "uknown error";

    // // Custom message berdasarkan status HTTP / kode network
    const status = e?.response?.status;
    const code = e?.code;
    const statusMessages = {
      //   400: "Permintaan tidak valid.",
      //   401: "Sesi Anda telah berakhir. Silakan login kembali.",
      //   403: "Anda tidak memiliki akses untuk melakukan tindakan ini.",
      //   404: "Data tidak ditemukan.",
      //   408: "Waktu permintaan habis. Silakan coba lagi.",
      413: "Ukuran file terlalu besar atau koneksi bermasalah. Mohon periksa limit ukuran file dan internet Anda.",
      //   415: "Format file tidak didukung.",
      //   429: "Terlalu banyak percobaan. Mohon tunggu sebentar sebelum mencoba lagi.",
      500: "Terjadi kesalahan pada server. Silakan coba lagi nanti.",
      502: "Server sementara tidak tersedia. Silakan coba lagi.",
      503: "Layanan sedang sibuk. Silakan coba lagi nanti.",
      504: "Waktu permintaan habis. Silakan coba lagi.",
    };
    const customMsg = statusMessages[status];
    if (customMsg) return customMsg;
    // ERR_NETWORK sering terjadi saat 413 (file terlalu besar) - server/proxy memutus koneksi
    // sebelum response diterima, sehingga response.status tidak tersedia
    if (code === "ERR_NETWORK" || e?.message === "Network Error") {
      const isUpload = e?.config?.data instanceof FormData;
      if (isUpload) {
        return "Ukuran file terlalu besar atau koneksi bermasalah. Mohon periksa limit ukuran file dan internet Anda.";
      }
      return "Koneksi bermasalah. Periksa internet Anda dan coba lagi.";
    }
    if (code === "ECONNABORTED") {
      return "Waktu permintaan habis. Silakan coba lagi.";
    }

    const msg =
      e.response && e.response.data && e.response.data.message
        ? e.response.data.message
        : e.response &&
          e.response.data &&
          e.response.data.error &&
          e.response.data.error.message
        ? e.response.data.error.message
        : e.response &&
          e.response.data &&
          e.response.data.status &&
          e.response.data.status.message
        ? e.response.data.status.message
        : e.response && e.response.data && e.response.data.detail
        ? e.response.data.detail
        : e.response && e.response.data
        ? e.response.data
        : e.data && e.data.message
        ? e.data.message
        : e.message
        ? e.message
        : e.reason
        ? e.reason
        : e.error
        ? e.error
        : e;

    return msg;
  },
};
